(() => {
  const source = document.currentScript?.dataset.chatSrc;
  if (!source) return;
  const loadChat = () => {
    if (document.querySelector('script[data-sp-chat-loaded]')) return;
    const script = document.createElement('script');
    script.src = source;
    script.async = true;
    script.referrerPolicy = 'no-referrer-when-downgrade';
    script.dataset.spChatLoaded = 'true';
    document.head.append(script);
  };
  const schedule = () => {
    setTimeout(() => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(loadChat, { timeout: 2000 });
      } else {
        loadChat();
      }
    }, 4000);
  };
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();

